import { render, staticRenderFns } from "./MyGrade.vue?vue&type=template&id=d386499e&"
import script from "./MyGrade.vue?vue&type=script&lang=js&"
export * from "./MyGrade.vue?vue&type=script&lang=js&"
import style0 from "./MyGrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports